export default "__VITE_ASSET__Df9Hb4hU__"